import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    AfterViewChecked,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';
import {ISubscription} from "rxjs/Subscription";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {CodeNameTranslate} from "app/shared/models/code-name-translate";
import {Formatters} from "../../../slick-grid/models/formatters";
import * as Popper from 'popper.js/dist/umd/popper';
import {CommonService} from "../../../services/common.service";
import {TabItem} from "app/buffer-graph/models/tab-item";
import {UniversalListSettings} from "../../models/universal-list";
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ISlickGridColumn} from "../../../slick-grid/interfaces/slick-grid-column";
import {SlickGridComponent} from "../../../slick-grid/slick-grid.component";
import {DataSorter} from 'app/slick-grid/models/data-sorter';
import {ColumnsGenerator} from "../../../slick-grid/models/columns-generator";
import {CodeName} from "../../../stocks/models/code-name";

@Component({
    selector: 'universal-list',
    templateUrl: './universal-list.component.html',
    styleUrls: [
        './universal-list.component.css',
        '../../../shared/styles/buttons.css'
    ]
})
export class UniversalListComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService,
                public readonly commonService: CommonService,
                public readonly elementRef: ElementRef
                ){

        this.selectionModel = new Slick.RowSelectionModel<any, Slick.Range[]>({selectActiveRow: false});
        this.selectionModelSelected = new Slick.RowSelectionModel<any, Slick.Range[]>({selectActiveRow: false});

        this.gridView = new Slick.Data.DataView<any>();
        this.gridView.getItemMetadata = this.metadata(this.gridView.getItemMetadata)
        this.cellCssStyles = {};
        this.gridView.onRowsChanged.subscribe(() => this.setMainGridSellStyles(this.gridView, 'cellCssStyles', true, 'filteredData'));
        this.cellCssStylesSelected = {};
        this.gridViewSelected = new Slick.Data.DataView<any>();
        this.gridViewSelected.onRowsChanged.subscribe(() => this.setMainGridSellStyles(this.gridViewSelected, 'cellCssStylesSelected', false,'filteredSelectedData'));

       this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true
        };

        this.optionsSelected = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true
        };

        this.helper = new ChartHelper();
        this.hide = new EventEmitter<{data: any[], selected: any[]}>();
        this.sorter = new DataSorter<any>();
        this.loadingOutput = new EventEmitter<boolean>();

        this.commonData.translateService.get(['Remove']).subscribe(t => this.translates = t);
        // this.dataOutput = new EventEmitter<{data: CodeNameTranslateChartTabs, mode: number}>();
        this.initialise();
    }

    private initialise = (): void =>{
        this.selected = [];
        this.clonedInData = [];
        this.timeOut = null;
        this.checkBoxHeader = null;
        this.maxPosition = { position: 0 };
        this.inputClass = {};
        //this.sortField = 'selected';
    };

    @HostListener('window:mouseup', ['$event']) onMouseUp(e: MouseEvent){
        if (this.mouseDown && this.checkDimensionsChange()){
            this.mouseDown = false;
            this.resizeGrid(true)
        }
    }

    private checkDimensionsChange = (): boolean => {
        let height = this.mainWrapper.nativeElement.offsetHeight,
            width = this.mainWrapper.nativeElement.offsetWidth,
            changed = this.height !== height || this.width !== width;
        if (changed){
            this.height = height;
            this.width = width;
        }
        return changed;
    }

    @Input() private GUID: string;
    @Input() private addRef: ElementRef | HTMLElement;
    @Input() private wrpRef: ElementRef | HTMLElement;
    @Input() private bndRef?: ElementRef | HTMLElement;
    @Input() private inData: any[];
    @Input() public settings: UniversalListSettings;
    @Input() private columnSettings: ColumnSettingsBase[];
    @Input() public titleKey: string;
    @Input() public columns: ISlickGridColumn<any>[];
    @Input() public readonly sorter?: DataSorter<any>;

    @Input() public customSelect?: (data: any[], filteredData: any[], selected: any[], row: any, maxPosition: { position: number}, selectAll: boolean) => void;

    @Input() set updatePopper(val: number){
        this.popperAddVar ? this.popperAddVar.update() : null;
    };

    @Input() set searchOut(val: string){
        this.searchData = val;

        const searchCommon = (grid: SlickGridComponent, func: () => void ): void => {
            if (!grid){
                let interval = setInterval(() => {
                    if (grid){
                        clearInterval(interval);
                        interval = null;
                        func();
                    }
                }, 100)
            } else {
                func();
            }
        }

        searchCommon(
            this.grid,
            () => this.filterData(this.gridView, 'data', 'filteredData', 'cellCssStyles', true, false)
        )
        searchCommon(
            this.gridSelected,
            () => this.filterData(this.gridViewSelected, 'selected', 'filteredSelectedData', 'cellCssStylesSelected', false, false)
        )
    };

    @Input() private readonly inClass?: string[];

    @Output()
    public readonly hide: EventEmitter<{data: any[], selected: any[]}>;

    @Output()
    private readonly loadingOutput: EventEmitter<boolean>;

    // @Output()
    // private readonly dataOutput: EventEmitter<{data: CodeNameTranslateChartTabs, mode: number}>;
    //
    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('gridsWrpEl')
    private gridsWrpRef: ElementRef;

    @ViewChild('itemsInfoEl')
    private itemsInfoRef: ElementRef;

    @ViewChild('gridWrpEl')
    private gridWrpRef: ElementRef;

    @ViewChild('gridWrpSelEl')
    private gridWrpSelRef: ElementRef;

    @ViewChild('grid')
    private grid: SlickGridComponent;

    @ViewChild('gridSelected')
    private gridSelected: SlickGridComponent;

    @ViewChild('inputSearchEl')
    private inputSearchEl: ElementRef;


    public readonly gridView: Slick.Data.DataView<TabItem>;
    public gridViewSelected: Slick.Data.DataView<TabItem>;
    public columnsGrid: Slick.Column<TabItem>[];
    public columnsGridSelected: Slick.Column<TabItem>[];
    public readonly options: Slick.GridOptions<TabItem>;
    public readonly optionsSelected: Slick.GridOptions<TabItem>;
    public readonly selectionModel: Slick.RowSelectionModel<TabItem, Slick.Range[]>;
    public readonly selectionModelSelected: Slick.RowSelectionModel<TabItem, Slick.Range[]>;
    public cellCssStyles: { [key: string]: Slick.CellCssStylesHash };
    public cellCssStylesSelected: { [key: string]: Slick.CellCssStylesHash};
    public data: any[];
    public _loading: boolean;
    private helper: ChartHelper;
    private subscriptionMouseMove: ISubscription;
    private popperAddVar: Popper;
    private translates: any;
    private listenMouseDown: () => void;
    private listenKeyboard: () => void;
    // private data: CompareItem[];
    public selected: any[];
    private filteredData: any[];
    private filteredSelectedData: any[];
    public searchData: string;
    private mouseDown: boolean;
    private timeOut: any;
    public showActivity: boolean;
    public outline: boolean;
    private checkBoxHeader: any;
    private maxPosition: { position: number} ;
    public sizeStyles: {[key: string]: string};
    public clonedInData: any[];
    public refreshGrids: boolean;
    public showSelectedGrid: boolean;
    public inputClass: {[index: string]: boolean};
    private subscription: ISubscription;
    private height: number;
    private width: number;
    private itemsInfoHeight: number;
    private gridHeight: number;
    private gridSelHeight: number;
    public initialized: boolean;
    public inited: boolean
    public boundaryRef: ElementRef | HTMLElement;
    //public sortField: string;

    // private listenContextMenu: () => void;


    async ngOnInit(){
        this.boundaryRef = this.bndRef ? this.bndRef : this.wrpRef;
        this.settings.hideListenerOnDom
            ? this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e))
            : this.subscription = this.commonService.mouseDownCurrent.subscribe((e: MouseEvent) => this.helper.tryCatch(() => e ? this.hideList(e) : null))

        this.listenKeyboard = this.renderer.listen('body', 'keyup', (e: KeyboardEvent) => {
            if (e){
                switch (e.keyCode){
                    case 13:
                        this.apply('Apply');
                        break;
                    case 27:
                        this.clearSearch();
                        break;
                }
            }
        });

        // this.subscription = this.commonService.mouseDownCurrent.subscribe((e: MouseEvent) => e ? this.hideList(e) : null);

        // this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideList(e));
        // this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(e =>
            this.helper.tryCatch(() => e && this.mouseDown && this.resizeGrid())
        );

        if (this.columnSettings && this.columnSettings.length){
            let generator = new ColumnsGenerator<CodeName>(this.translateService, this.renderer, this.elementRef);
            this.columnsGrid = await generator.columnsGenerate([], this.columnSettings, true)
            this.columnsGridSelected = await generator.columnsGenerate([], this.columnSettings, true)
        } else {
            this.columnsGrid = this.columns.map(item => item);
            this.columnsGridSelected = this.columns.map(item => item);
        }

        if (!this.settings.applyOneClick){
            this.columnsGrid.unshift({
                id: 'selected',
                field: 'selected',
                name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
                sortable: false,
                width: 20,
                formatter: Formatters.checkBoxFormatter
            });
        }


        this.columnsGridSelected.push({
            id: 'remove',
            field: 'remove',
            name: '',
            sortable: false,
            width: 30,
            maxWidth: 30,
            formatter: (r, c, v) => this.formatRemoveCell(r, c, v),
            resizable: false
        });

        this.data = this.clone(this.inData);
        this.filteredData = this.data;
        this.maxPosition.position = Math.max.apply(Math, this.data.map(o =>  o.position ));
        this.gridView.setItems(this.filteredData);

        this.selected = this.data.filter(item => item.selected);
        this.filteredSelectedData = this.selected;
        this.filteredSelectedData.sort((a: any, b: any) => {
            return a['position'] - b['position'];
        });
        this.gridViewSelected.setItems(this.filteredSelectedData);
        this.helper.wait(() => this.setSelectedRows());

        this.setMaxDimension('Height');
        this.setMaxDimension('Width');

        this.sizeStyles = {
            'width': this.settings.startWidth + 'px',
            'height': this.settings.startHeight + 'px'
        };

        if (this.settings.changeSizes) {
            this.sizeStyles['min-width'] = this.settings.minWidth + 'px';
            this.sizeStyles['min-height'] = this.settings.minHeight + 'px';
            this.sizeStyles['max-width'] = this.settings.maxWidth + 'px';
            this.sizeStyles['max-height'] = this.settings.maxHeight + 'px';
        }

        if (this.settings.openSelectedList){
            this.showSelectedGrid = true;
        }

        this.generateClass();
        this.initialized = true;
        this.inited = true;
    }

    ngOnDestroy(){
        this.listenMouseDown && this.listenMouseDown();
        this.listenKeyboard && this.listenKeyboard();
        this.subscription && this.subscription.unsubscribe();
    }

    ngAfterViewInit(){

    }

    ngAfterViewChecked(){
        if (this.refreshGrids){
            this.refreshGrids = false;
            if (this.grid){
                this.grid.resizeGrid();
            }
            if (this.gridSelected){
                this.gridSelected.resizeGrid();
            }
        }

        if (this.inited) {
            this.inited = false;
            // this.helper.wait(() => this.setMainGridSellStyles(this.gridView, 'cellCssStyles'));

            if(this.gridWrpSelRef && this.gridWrpSelRef.nativeElement){
                if (this.columnsGridSelected.length === 2){
                    this.gridSelected.setOptions({ forceFitColumns: true})
                    this.gridSelected.setColumns(this.columnsGridSelected);
                }
            }

            if (this.inputSearchEl && this.inputSearchEl.nativeElement) {
                this.helper.wait(() => this.inputSearchEl.nativeElement.focus());
            }

            this.popperAdd();
            this.helper.wait(() => this.resizeGrid(true));
        }
    }

    private clone = (data: any[]): any[] => {
        if (this.settings.cloneIncomingData) {
            data.forEach((element: any) => {
                let obj: any = element.clone ? element.clone() : this.helper.deepCopy(element);
                this.clonedInData.push(obj);
            });
            return this.clonedInData;
        }

        return data;
    }

    private readonly setMaxDimension = (dimension: 'Width' | 'Height'): void => {
        let dimensionVal = this.wrpRef && (this.wrpRef as ElementRef).nativeElement
                ? (this.wrpRef as ElementRef).nativeElement['offset' + dimension]
                : (this.wrpRef as HTMLElement)['offset' + dimension];

        dimensionVal = dimensionVal < 200 ? 200 : dimensionVal;

        if (this.settings['start' + dimension] > dimensionVal){
            this.settings['start' + dimension] = dimensionVal;
            this.settings['max' + dimension] = dimensionVal;
            this.settings['min' + dimension] = dimensionVal;
        }
    }

    //# set filter on grid
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }

        if (this.grid){
            this.grid.setFreezeColumns(this.settings.frozenColumnsNum);
            this.helper.wait(this.grid.checkAllSelect, 2000)
            //this.grid.checkAllSelect();
        }

        this.gridView.setFilter(o => this.grid.filterHelper.filter(o));

    }

    //# set filter on grid
    public setFilterSelected = (val: boolean): void => {
        if (!val){
            return;
        }
        this.gridViewSelected.setFilter(o => this.gridSelected.filterHelper.filter(o));
    }

    private metadata = function (old_metadata_provider){

        return function (row){
            let item: CodeName = this.getItem(row);
            let ret = (old_metadata_provider(row) || {});

            if (item.disabled){
                ret.cssClasses = (ret.cssClasses || '');
                ret.cssClasses += ' disabled';
            }
            return ret;
        }
    };


    //# toggle tab selection
    public onGridClick = (args: any): void =>{
        let data = this.gridView.getItem(args.data.row),
            el = args.event.target,
            row = args.data.row;
        this.gridView.getItem(args.data.row);

        if (data.disabled || el.tagName.toLowerCase() === 'input'){
            return;
        }

        if (this.settings.applyOneClick){
            this.selected.length = 0;
            this.data.forEach(item => item.selected = false );
        }

        this.selectRow(data);
        this.grid.updateRow(row);
        this.setMainGridSellStyles(this.gridView, 'cellCssStyles', true, 'filteredData')

        this.gridViewSelected ? this.gridViewSelected.setItems(this.selected) : null;

        if (this.settings.applyOneClick) {
            this.apply('Apply');
        }
    };

    //# toggle tab selection
    public onGridClickSelected = (args: any): void =>{
        let data = this.gridViewSelected.getItem(args.data.row),
            el = args.event.target,
            row = args.data.row;

        if (el.classList.contains('fa-xmark')){
            this.selectRow(data);
            this.grid.updateRow(row);

            this.gridViewSelected.setItems(this.filteredSelectedData);
            this.setMainGridSellStyles(this.gridView, 'cellCssStyles', true,'filteredData')
            return;
        }
    };

    public sortColumns = (columns: Slick.Column<any>[]): void => {
        columns.sort((a: any, b: any) =>{
             return a.id === 'selected' ? - 1 : b.id === 'selected' ? 1 : 0;
        });
    };

    public sortColumnsSelected = (columns: Slick.Column<any>[]): void => {
        columns.sort((a: any, b: any) =>{
            return a.id === 'remove' ? 1 : b.id === 'remove' ? -1 : 0;
        });
    };

    //# toggle select for row in grid
    public selectRow = (row: any, node?: HTMLElement): void =>{
        row.selected = !row.selected;
        if (row.selected){
            this.maxPosition.position =  row.position = ++this.maxPosition.position;
        }
        row.selected ? this.selected.push(row) : this.helper.remFromArr(this.selected, 'id', row.id);
        this.customSelect ? this.customSelect(this.data, this.filteredData, this.selected, row, this.maxPosition, null) : null;
        this.setSelectedRows();
    };

    //# set selected row in grid, set to selected row color
    public setSelectedRows = (): void =>{
        let selected = this.helper.getRowsFromGridAll(this.gridView).filter(item => item.selected),
            id = selected.map(item => this.gridView.getRowById(item.id.toString()));
        if (this.grid){
            this.grid.setSelectedRows(id);
            this.grid.invalidate();
        }

        !this.settings.applyOneClick && this.checkAllSelect();
    };

    //# if all tabs is selected we set "all select" checkbox checked, in otherwise set "all select" checkbox not checked.
    private checkAllSelect = (): void =>{
        let allSelected = this.filteredData.length ? this.helper.getRowsFromGridAll(this.gridView).every(item => item.selected) : false;
        if (this.checkBoxHeader){
            this.helper.wait(() => this.checkBoxHeader.checked = allSelected, 100);
        }
    };

    public onGridDblClick = (args: any): void =>{

    };

    //# enable loading image in inform about it parent component
    set loading(val: boolean){
        if (val !== this._loading){
            this._loading = val;
            this.helper.wait(() => this.loadingOutput.emit(val));
        }
    }

    get loading(): boolean{
        return this._loading;
    }

    //# add listener to "select all" checkbox
    public slickGridHeaders = (args: any): void =>{
        if (args.data.column.id === 'selected'){
            this.checkBoxHeader = args.data.node.querySelector('input');
            this.renderer.listen(this.checkBoxHeader, 'change', e => this.selectAll(e.target.checked));
        }
    };

    //# toggle all select
    private selectAll = (select: boolean): void =>{
        let items = this.helper.getRowsFromGridAll(this.gridView);

        !select ? this.selected.length = 0 : null;

        items.forEach(item =>{
            !item.disabled ? item.selected = select : null;
            if (select){
                let has: boolean = this.selected.some(inItem => item[this.settings.selectAllField] === inItem[this.settings.selectAllField]);

                !has ? this.selected.push(item) : null;
                !has ? this.maxPosition.position = item.position = ++this.maxPosition.position : null

            } else{
                item.selected && this.selected.push(item)
                // this.data.selected.forEach(inItem => item.code === inItem.code ? has = true : null);
                // has ? this.helper.remFromArr(this.data.selected, 'code', item.code) : null;
            }
        });
        // !select ? this.selected.length = 0 : null;

        // this.data.selected.length = 0;
        //this.gridView.setItems([]);
        this.gridView.setItems(this.filteredData);
        this.gridViewSelected.setItems(this.selected);
        this.setSelectedRows();
    };

    //# add popper to this component
    public popperAdd = (): void =>{
        this.popperAddVar = this.helper.popperAdd(this.addRef, this.mainWrapper, this.boundaryRef, this.settings.popper.placement, this.settings.popper.behavior, true);
    };

    //# hide list
    private hideList = (e: MouseEvent): void =>{

        let clickOnList = this.helper.hideList(this.mainWrapper, e, this.renderer);

        if (clickOnList){

            this.helper.wait(() =>{
                this.settings.emitOnClose
                    ? this.settings.disableOkNoneSelected && !this.selected.length
                        ? this.hide.emit(null)
                        : this.hide.emit({data: this.data, selected: this.selected})
                    : this.hide.emit(null);
            }, 250);
        } else {
            this.mouseDown = true;
            this.height = this.mainWrapper.nativeElement.offsetHeight;
            this.width = this.mainWrapper.nativeElement.offsetWidth;
        }
    };

    //# search in list
    public filterSearch = (e?: KeyboardEvent, keyDown?: boolean): void =>{

        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17 || e.keyCode === 18)) return;

        if (e && e.keyCode === 27 && !keyDown){
            return;
        }

        if (e && e.keyCode === 9 && this.loading){
            e.preventDefault();
            return;
        }

        if (e && e.keyCode === 9 && e.repeat){
            e.preventDefault();
            return;
        }

        this.filterAllData(keyDown);
    };

    //# search in list
    public filterSearchPaste = (e?: ClipboardEvent, keyDown?: boolean): void =>{
        this.helper.wait(() => {
            this.filterAllData(keyDown);
        }, 10)
    };

    public readonly filterAllData = (keyDown: boolean): void =>{
        this.filterData(this.gridView, 'data', 'filteredData', 'cellCssStyles', true, keyDown);
        this.filterData(this.gridViewSelected, 'selected', 'filteredSelectedData', 'cellCssStylesSelected', false, keyDown);
    }

    /**
     * Filter
     */

    private filterData = (view: Slick.Data.DataView<TabItem>, data: string, filteredData: string, stylesObjName: string, setSelected: boolean, keyDown: boolean): void => {

        let matchData: string[] = [];
        if (this.searchData && !keyDown){
            matchData = this.searchData.split(' ').map(item => item.trim());
        }

        if (data && data.length > 0 && !keyDown){

            if (this.searchData && this.searchData.length > 0){
                this[filteredData] = this[data].filter(item =>{
                    let propArr: string[] = []
                    for (let prop in item){
                        if (typeof item[prop] === 'string'){
                            item[prop + 'Find'] = this.helper.matchText(matchData, item[prop]);
                            propArr.push(prop + 'Find')
                        }
                    }
                    // item.findCode = this.helper.matchText(data, item.code);
                    // item.findName = this.helper.matchText(data, item.name);
                    // return item.findCode || item.findName;
                    return propArr.some(p => item[p]);
                });
            } else{
                this[data].forEach(item =>{
                    for (let prop in item){
                        // let found = prop.match(/[\w\-]+Find/);
                        if (prop.substr(prop.length - 4) === 'Find'){
                            item[prop] = false;
                        }
                    }
                    // item.findCode = false;
                    // item.findName = false;
                });
                this[filteredData] = this[data];
            }


            view.setItems([]);
            // view.beginUpdate()
            view.setItems(this[filteredData]);
            // view.endUpdate();
            // this.setMainGridSellStyles(view, stylesObjName, setSelected)
            //this.columnWidth();

        }
    }

    //# set color for grid sells
    private setCellStyles = (gridView: Slick.Data.DataView<any>, stylesObjName: string, setSelected: boolean): void =>{
        let mainStyles = null;

        this.helper.getRowsFromGrid(gridView).forEach((row: CodeNameTranslate) => mainStyles = this.setCellMainStyles(mainStyles, row, gridView.getIdxById(row.id), setSelected));
        const styles = {};
        if (mainStyles === null) mainStyles = {};
        styles['main-styles2'] = mainStyles;
        this[stylesObjName] = styles;
        // this.cellCssStyles = styles;

    };

    //# generate colors for grid sells on row
    private setCellMainStyles = (hash: Slick.CellCssStylesHash, row: any, index: number, setSelected: boolean = true): Slick.CellCssStylesHash =>{
        let styles = null,
            props: string[] = Object.getOwnPropertyNames(row);
        props.forEach(prop => {
            let styleObj = {};

            if (setSelected && row['selected']){
                styleObj[prop] ? styleObj[prop] += ' selected' : styleObj[prop] = 'selected';
                styles = Object.assign(styles || {}, styleObj);
            }

            if (prop.substr(prop.length - 4) === 'Find' && row[prop]){
                let key = prop.slice(0, -4);
                styleObj[key] ? styleObj[key] = styleObj[key] + ' found' : styleObj[key] = 'found';
                styles = Object.assign(styles || {}, styleObj);
            }
        })

        if (!styles)
            return hash;

        if (!hash)
            hash = {};
        hash[index] = styles;

        return hash;
    };

    //# ask question in which mode open tabs
    /*public showSelect = (): void =>{
        let first: string = 'OpenTabsInSingleMode',
            second: string = 'OpenTabsInViewMode';
        if (this.data.viewMode === null && this.data.selected.length > 1){
            this.translateService.get([first, second])
                .subscribe(s => this.commonData.showRadioSelection([s[first], s[second]], (idx: number) => this.apply('Apply', idx)));
            return;
        } else {
            let mode = this.data.viewMode === null ? 1 : this.data.viewMode;
            this.apply('Apply', mode)
        }
    };*/

    /**
     * clear filter and emit empty selected list
     */
    public readonly clearFilter = (): void => {
        this.data.forEach(d => d.selected = false);
        this.selected.length = 0;
        this.apply('Apply')
    }

    //# apply selection
    public apply = (command: 'Apply' | 'Cancel', mode: number = null): void =>{
        switch (command){
            case 'Apply':
                this.hide.emit({data: this.data, selected: this.selected});
                break;
            case 'Cancel':
                this.hide.emit(null );
                break;
            default:
                this.hide.emit(null );
                break;
        }
    };

    public clearSearch = (): void => {
        this.searchData = '';
        this.filterSearch();
    }

    //# resize grid when dimensions of wrapper changing
    public resizeGrid = (last?: boolean): void =>{
        if (this.grid && this.mouseDown){
            if (this.timeOut){
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }

            this.timeOut = setTimeout(() =>{
                //this.columnWidth();
                this.grid.resizeGrid();
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }, 100);
        } else if (this.grid && last){
            this.helper.wait(() => {
                this.columnWidth(this.grid, this.gridWrpRef, this.columnsGrid, this.filteredData);
                this.columnWidth(this.gridSelected, this.gridWrpSelRef, this.columnsGridSelected, this.selected, 2);
            });
        }
    };

    //# recalculate grid column width when dimensions of wrapper changing
    private columnWidth = (grid: SlickGridComponent, gridWrpRef: ElementRef, columns: Slick.Column<TabItem>[], data: any[], columnChange: number = 1): void =>{
        if (!gridWrpRef || !grid){
            return;
        }

        let slickScrollWidth = 12,
            gridWidth = gridWrpRef.nativeElement.offsetWidth - 2,
            gridHeight = gridWrpRef.nativeElement.offsetHeight,
            sumColumnWidth = 0;
        let stringQuantity = Math.floor((gridHeight - 5) / 25) - 1;
        if (data.length > stringQuantity){
            gridWidth = gridWidth - slickScrollWidth;
        }

        columns.forEach(item => sumColumnWidth += item.width);

        if (sumColumnWidth < gridWidth){
            //let lasrColWidth = this.columnsGrid[this.columnsGrid.length - 1].width;
            columns[columns.length - columnChange].width += gridWidth - sumColumnWidth;
        } else if (sumColumnWidth > gridWidth){

        }



        // this.columnsGrid.forEach(item =>{
        //     if (item.field !== 'name'){
        //         width = width - item.width;
        //     }
        // });
        //
        // this.columns.forEach(item =>{
        //     if (item.field === 'name' && width > 100){
        //         item.width = width;
        //     }
        // });

        grid.setColumns(columns);

        this.refreshGrids = true;

        this.checkAllSelect();
        // this.popperAddVar.destroy();
        // this.popperAdd();
    }

    public onGridKeyDown = (args: any): void =>{
        if (args.event.keyCode === 32){
            this.onGridClick(args);

        } else if (args.event.keyCode === 13){

        } else if (args.event.keyCode === 27){

        } else if (args.event.keyCode === 9 && args.event.originalEvent.shiftKey && args.event.originalEvent.repeat){

        } else if (args.event.keyCode === 9 && args.event.originalEvent.shiftKey){

        } else if (args.event.keyCode === 9 && args.event.originalEvent.repeat){

        } else if (args.event.keyCode === 9){

        }
    };

    //# render icon for remove
    private formatRemoveCell = (r, c, v): string => {
        return `<span class="fa-solid fa-xmark" data-toggle="tooltip" title="${this.translates['Remove']}" style="cursor: pointer"></span>`;
    };

    public readonly toggleSelectedTable = (e) => {
        if (this.settings.showOnlySelectedList){
            return;
        }
        this.showSelectedGrid = !this.showSelectedGrid;
        this.refreshGrids = true;
    }

    private generateClass = (): any =>{
        this.inClass && this.inClass.length ? this.inClass.forEach(item => this.inputClass[item] = true) : null;
    }

    protected setMainGridSellStyles = (view: Slick.Data.DataView<TabItem>, stylesObjName: string, setSelected: boolean, prop?: string): void => {
        this.setCellStyles(view, stylesObjName, setSelected);
        this.helper.setCellStyles(view, this[stylesObjName]);
        // view.refresh();
    }

    public searchBlur = (): void => {
        this.outline = false
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/universal-list.component/universal-list.component.ts